import { computed } from 'vue';
import { canUseFeatureUnlessPersonalTrialExpired } from './soft-paywall';
import type { TrialExpiryGatedFeature } from './trial-expiry-gated-features';
import { useLicense } from './useLicense';

/** Whether the user can use a trial-expiry-gated Pro feature (e.g. presentation mode). */
export function useCanUseTrialExpiryGatedFeature(
  feature: TrialExpiryGatedFeature,
) {
  const { paywallLicenses } = useLicense();

  return computed(() => {
    const hasFeature = paywallLicenses.value.some((license) =>
      license.features.some((licenseFeature) => licenseFeature.key === feature),
    );

    return canUseFeatureUnlessPersonalTrialExpired(
      hasFeature,
      paywallLicenses.value,
    );
  });
}
